<template>
  <base-campaign-targeting-rule>
    <div>
      <div v-for="(sentence, key) in getDescription" :key="key">
        <div style="line-height: 1.2">{{ sentence }}</div>
        <strong v-if="data.length - 1 > key">OR</strong>
      </div>
    </div>
  </base-campaign-targeting-rule>
</template>

<script>
import BaseCampaignTargetingRule from "@/components/campaign-targeting-rules/BaseCampaignTargetingRule"
import targetingRuleMixin from "@/mixins/targeting-rule-mixin"
import { mapState } from "vuex"
import stringCompareOperators from "@/components/campaign-targeting-rules/stringCompareOperators"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"

const mixin = targetingRuleMixin("who", targetingRuleNames.whoRules.lastVisitedUrl)

export default {
  name: "TargetingLastVisitedUrl",
  components: {
    BaseCampaignTargetingRule
  },
  mixins: [mixin],
  computed: {
    ...mapState("sites", ["selectedSite"]),
    getDescription() {
      return this.data.map((row) => {
        return `Last visited page url ${stringCompareOperators[row.filter].toLowerCase()} ${
          this.showDomain(row.filter) ? this.selectedSite.domain + "/" : ""
        }${row.value}`
      })
    }
  },
  methods: {
    showDomain(filter) {
      return filter === "equals" || filter === "notEquals" || filter === "startsWith" || filter === "notStartsWith"
    }
  }
}
</script>
